import { useMutation, useQueryCache } from 'react-query';
import { addCenters } from 'src/services/api/users';

function useAddCenters() {
  const queryCache = useQueryCache();

  return useMutation(({ user, data }) => addCenters(user, data), {
    onSuccess: (data) => queryCache.setQueryData(['user', data.data?.id], data),
  });
}

export default useAddCenters;
